import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';
import { getCookieConsent, setCookieConsent } from '../utils/cookieConsent';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    setCookieConsent({
      necessary: true,
      analytics: true
    });
    setIsVisible(false);
  };

  const handleRejectNonEssential = () => {
    setCookieConsent({
      necessary: true,
      analytics: false
    });
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black border-t-2 border-gray-700 shadow-2xl animate-slide-up">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-4 flex-1">
            <div className="hidden md:block mt-1">
              <Cookie className="w-8 h-8" style={{ color: '#32a86c' }} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
                <Cookie className="w-5 h-5 md:hidden" style={{ color: '#32a86c' }} />
                We Use Cookies
              </h3>
              <p className="text-sm text-gray-300 mb-3">
                We use cookies to improve your experience on our website, analyse site traffic, and understand where our visitors are coming from.
              </p>
              <p className="text-sm text-gray-300 mb-3">
                By clicking "Accept All", you consent to our use of cookies including analytics cookies.
              </p>
              <Link
                to="/cookies-policy"
                className="text-sm font-semibold hover:underline inline-block"
                style={{ color: '#32a86c' }}
                onClick={handleClose}
              >
                Learn more about our cookie policy
              </Link>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={handleRejectNonEssential}
              className="px-4 py-2.5 rounded-lg font-medium text-sm transition-all border-2 text-white border-gray-600 hover:border-gray-500 hover:bg-gray-800 whitespace-nowrap"
            >
              Reject Non-Essential
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-2.5 rounded-lg font-medium text-sm text-white transition-all shadow-md hover:shadow-lg whitespace-nowrap"
              style={{ backgroundColor: '#32a86c' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a9760'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#32a86c'}
            >
              Accept All
            </button>
          </div>
        </div>

        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-300 transition-colors"
          aria-label="Close cookie banner"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
